import * as types from './mutation-types'

export default {
    [types.SET_BOLETO_EXPRESSO](state, boletos) {
        state.boletos = boletos
    },
}